import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, Subject, catchError, map, of, take } from 'rxjs'
import { ICustomOrder } from '../../models/ICustomOrder'
import { ICustomOrderEntry } from '../../models/ICustomOrderEntry.interface'
import { AppConfigurationService } from '../app-configuration.service'
import { SharedService } from '../shared/shared.service'

@Injectable({
  providedIn: 'root'
})
export class CustomOrderHistoryService {
  private _orderUpdated = new Subject<any>()
  public orderUpdated$: Observable<any> = this._orderUpdated.asObservable()

  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private sharedService: SharedService
  ) {}

  public getOrderDetails(code: string): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/orders/${code}?fields=FULL`
    return this.http.get(url).pipe(
      catchError((err) => {
        return this.sharedService.handleError(
          err
          // "Unable to get order details."
        )
      })
    )
  }

  public getSubscriptionOrderDetails(code: string): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/users/current/orders/${code}?fields=FULL`
    return this.http.get(url).pipe(
      map((res: ICustomOrder) => {
        const newEntries = res.entries?.filter((item: ICustomOrderEntry) => item.isSubscriptionEntry)
        const newResponse = { ...res, entries: newEntries }
        return newResponse
      }),
      catchError((err) => {
        return this.sharedService.handleError(
          err
          // "Unable to get order details."
        )
      })
    )
  }

  public getSubscriptionOrders(payload?: { currentPage; sortCode }): Observable<any> {
    let params: HttpParams = new HttpParams()
    if (payload?.currentPage) {
      params = params.set('currentPage', payload.currentPage)
    }
    if (payload?.sortCode) {
    }

    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/b2c/users/current/subscriptionOrders?pageSize=5`
    return this.http.get(url, { params }).pipe(
      map((res: any) => {
        const newResponse = JSON.parse(JSON.stringify(res))
        newResponse.sorts = res.sorts?.map((item) => {
          return {
            code: `${item.code}`,
            selected: item.selected
          }
        })
        newResponse.pagination = {
          currentPage: res.pagination?.page,
          pageSize: res.pagination?.count,
          sort: 'creationtime',
          totalPages: res.pagination?.totalPages,
          totalResults: res.pagination?.totalCount
        }
        return newResponse
      })
    )
  }

  public cancelOrder(orderId: string): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/b2c/order/cancel`
    return this.http
      .post(url, null, {
        params: { orderCode: orderId }
      })
      .pipe(
        catchError((err) => {
          return this.sharedService.handleError(
            err
            // "Order cannot be cancelled."
          )
        })
      )
  }

  public orderUpdated(order: any): void {
    order = of(order)
    this._orderUpdated.next(order)
  }

  public editOrder(orderId: string, payload: any): Observable<any> {
    const baseSiteUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseSiteUrl}/b2c/order/edit`
    return this.http
      .post(url, payload, {
        params: {
          orderCode: orderId,
          fields: 'FULL'
        }
      })
      .pipe(
        catchError((err) => {
          return this.sharedService.handleError(
            err
            // "Order could not be edited."
          )
        })
      )
  }

  imageUrlToBase64(urL: string) {
    return this.http
      .get(urL, {
        observe: 'body',
        responseType: 'arraybuffer'
      })
      .pipe(
        take(1),
        map((arrayBuffer) =>
          btoa(
            Array.from(new Uint8Array(arrayBuffer))
              .map((b) => String.fromCharCode(b))
              .join('')
          )
        )
      )
  }
}
